if (!customElements.get('product-list-scrollbar')) {
  customElements.define('product-list-scrollbar', class extends HTMLElement {
    connectedCallback() {
      this.slider = this.closest('slider-component').querySelector('[id^="Slider-"]');
      this.input = this.querySelector('input');
      this.update = () => {
        const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
        this.hidden = maxScroll <= 1;
        this.input.value = maxScroll > 0 ? Math.abs(this.slider.scrollLeft) / maxScroll * 100 : 0;
        this.style.setProperty('--thumb-width', `${Math.max(24, this.slider.clientWidth / this.slider.scrollWidth * this.clientWidth)}px`);
      };
      this.onInput = () => {
        const direction = getComputedStyle(this.slider).direction === 'rtl' ? -1 : 1;
        this.slider.scrollTo({
          left: direction * this.input.value / 100 * (this.slider.scrollWidth - this.slider.clientWidth),
          behavior: 'instant'
        });
      };
      this.slider.addEventListener('scroll', this.update, { passive: true });
      this.input.addEventListener('input', this.onInput);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.slider);
      this.observer.observe(this);
      this.update();
    }

    disconnectedCallback() {
      this.slider.removeEventListener('scroll', this.update);
      this.input.removeEventListener('input', this.onInput);
      this.observer.disconnect();
    }
  });
}
